export class ProcessModel {
    constructor(
        public id:any,
        public reportInstanceId: number,
        public reportDocId: number,
        public status: string,
        public startTime: string,
        public endTime: string,
        public createdDt: Date,
        public createdBy: string,
        public updatedDt: Date,
        public updatedBy: string,
        public reportName: string,
        public reportDesc: string,
        public instanceName: string,
        public distId: string,
        public distName: string,
        public distType: string,
        public distValue: string
    ) { }
}
